<template>
  <section v-if="displayList.length" class="ni-section ni-vr" id="vr-hall">
    <div class="ni-container">
      <SectionHeader
        variant="dark"
        subtitle="EXCHANGE"
        more-href="/fvr"
        :lang="lang"
      >
        <template #title>
          <span class="ni-section-header__title-mark">
            {{ lang === 'zh' ? 'VR展馆' : 'VR Gallery' }}
          </span>
        </template>
      </SectionHeader>

      <div class="ni-vr__grid">
        <a
          v-for="expo in displayList"
          :key="expo.id"
          :id="`vr-card-${expo.id}`"
          class="ni-vr__card"
          :href="expo.href"
          target="_blank"
          rel="noopener noreferrer"
          :title="expo.title"
        >
          <div class="ni-vr__card-media">
            <img :src="expo.imageUrl" :alt="expo.title" />
            <span class="ni-vr__card-enter">
              {{ lang === 'zh' ? '点击进入' : 'Enter' }}
            </span>
          </div>
          <div class="ni-vr__card-footer">
            <p class="ni-vr__card-title">{{ expo.title }}</p>
          </div>
        </a>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import SectionHeader from './shared/SectionHeader.vue';

const props = defineProps({
  lang: {
    type: String,
    default: 'zh',
    validator: (value) => ['zh', 'en'].includes(value),
  },
  vrList: {
    type: Array,
    default: () => [],
  },
});

const displayList = computed(() => (props.vrList || []).slice(0, 6));
</script>
